var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "统一上传进度",
            visible: _vm.visible,
            width: "95%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.stopPolling,
          },
        },
        [
          _vm.batch
            ? _c(
                "div",
                { staticClass: "batch-summary" },
                [
                  _c("span", [_vm._v("批次号：" + _vm._s(_vm.batch.batchNo))]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("版本号：" + _vm._s(_vm.batch.versionNo)),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("总数：" + _vm._s(_vm.batch.totalCount))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "success-text" }, [
                    _vm._v("成功：" + _vm._s(_vm.batch.successCount)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "danger-text" }, [
                    _vm._v("失败：" + _vm._s(_vm.batch.failedCount)),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("进行中：" + _vm._s(_vm.batch.runningCount)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getBatchStatus(_vm.batch.batchStatus).type,
                        size: "mini",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.getBatchStatus(_vm.batch.batchStatus).label
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.batch ? _vm.batch.versions : [],
                border: "",
                size: "mini",
                "max-height": "570",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "appName",
                  label: "小程序",
                  "min-width": "135",
                  fixed: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appId",
                  label: "AppID",
                  width: "155",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "执行步骤", "min-width": "570" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-steps",
                          {
                            attrs: {
                              active: _vm.getUploadStep(scope.row),
                              "process-status":
                                scope.row.uploadStatus === "FAILED"
                                  ? "error"
                                  : "process",
                              "finish-status": "success",
                              "align-center": "",
                            },
                          },
                          [
                            _c("el-step", { attrs: { title: "创建任务" } }),
                            _vm._v(" "),
                            _c("el-step", { attrs: { title: "拉取代码" } }),
                            _vm._v(" "),
                            _c("el-step", { attrs: { title: "环境校验" } }),
                            _vm._v(" "),
                            _c("el-step", {
                              attrs: { title: "HBuilderX编译" },
                            }),
                            _vm._v(" "),
                            _c("el-step", { attrs: { title: "微信上传" } }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        scope.row.currentStep === "WAITING_BUILD"
                          ? _c("div", { staticClass: "waiting-tip" }, [
                              _vm._v("正在排队等待 HBuilderX 全局锁"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "targetDomain",
                  label: "目标域名",
                  "min-width": "210",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.targetDomain || "-"))]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", width: "105" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getUploadStatus(scope.row.uploadStatus)
                                .type,
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getUploadStatus(scope.row.uploadStatus)
                                    .label
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "uploadErrorMessage",
                  label: "失败原因",
                  "min-width": "190",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(scope.row.uploadErrorMessage || "-")),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "110", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.showLog(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("日志")]
                        ),
                        _vm._v(" "),
                        _vm.canCancelUpload(scope.row.uploadStatus)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:miniapp:release:upload"],
                                    expression:
                                      "['admin:miniapp:release:upload']",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  size: "mini",
                                  loading: _vm.cancelingId === scope.row.id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.cancelUpload(scope.row)
                                  },
                                },
                              },
                              [_vm._v("中止")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传任务日志",
            visible: _vm.logVisible,
            width: "760px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.logVisible = $event
            },
          },
        },
        [
          _vm.versionDetail
            ? _c("div", { staticClass: "log-meta" }, [
                _c("span", [_vm._v(_vm._s(_vm.versionDetail.appName))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.versionDetail.versionNo))]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.getUploadStatus(_vm.versionDetail.uploadStatus).label
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("pre", { staticClass: "build-log" }, [
            _vm._v(
              _vm._s(
                _vm.versionDetail
                  ? _vm.versionDetail.buildLog || "暂无日志"
                  : "加载中..."
              )
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }